import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

var EquisFadeBackgroudColor;
(function (EquisFadeBackgroudColor) {
    EquisFadeBackgroudColor["WHITE"] = "white";
    EquisFadeBackgroudColor["GRAY"] = "gray";
})(EquisFadeBackgroudColor || (EquisFadeBackgroudColor = {}));

class EquisFadeComponent {
    constructor() {
        this._backgroundColor = EquisFadeBackgroudColor.WHITE;
    }
    set backgroundColor(backgroundColor) {
        this._backgroundColor = Object.values(EquisFadeBackgroudColor).includes(backgroundColor)
            ? backgroundColor
            : EquisFadeBackgroudColor.WHITE;
        if (this._backgroundColor === EquisFadeBackgroudColor.GRAY) {
            this.background = 'fade--gray';
        }
        if (this._backgroundColor === EquisFadeBackgroudColor.WHITE) {
            this.background = 'fade--white';
        }
    }
}
EquisFadeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisFadeComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
EquisFadeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: EquisFadeComponent, selector: "z-fade , equis-fade", inputs: { backgroundColor: "backgroundColor" }, ngImport: i0, template: "<div class=\"fade\" [ngClass]=\"'fade--' + _backgroundColor\">\n  <ng-content></ng-content>\n</div>\n", styles: [".fade{align-items:center;bottom:0;display:flex;justify-content:center;left:0;padding:24px 16px 16px;position:fixed;right:0;z-index:100}.fade--white{background:linear-gradient(180deg,rgba(250,250,250,.0001) 0%,rgba(250,250,250,.92) 14.87%,#ffffff 31.71%,#ffffff 100%)}.fade--gray{background:linear-gradient(180deg,rgba(250,250,250,.0001) 0%,rgba(250,250,250,.92) 14.87%,#fafafa 31.71%,#fafafa 100%)}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisFadeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'z-fade , equis-fade', template: "<div class=\"fade\" [ngClass]=\"'fade--' + _backgroundColor\">\n  <ng-content></ng-content>\n</div>\n", styles: [".fade{align-items:center;bottom:0;display:flex;justify-content:center;left:0;padding:24px 16px 16px;position:fixed;right:0;z-index:100}.fade--white{background:linear-gradient(180deg,rgba(250,250,250,.0001) 0%,rgba(250,250,250,.92) 14.87%,#ffffff 31.71%,#ffffff 100%)}.fade--gray{background:linear-gradient(180deg,rgba(250,250,250,.0001) 0%,rgba(250,250,250,.92) 14.87%,#fafafa 31.71%,#fafafa 100%)}\n"] }]
        }], propDecorators: { backgroundColor: [{
                type: Input
            }] } });

class EquisFadeModule {
    static forRoot() {
        return {
            ngModule: EquisFadeModule,
        };
    }
}
EquisFadeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisFadeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EquisFadeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: EquisFadeModule, declarations: [EquisFadeComponent], imports: [CommonModule], exports: [EquisFadeComponent] });
EquisFadeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisFadeModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisFadeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EquisFadeComponent],
                    imports: [CommonModule],
                    exports: [EquisFadeComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { EquisFadeBackgroudColor, EquisFadeComponent, EquisFadeModule };
